module.exports = __webpack_public_path__ + "static/img/star_person_service.9e0912cc.png";